// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"8261319b","45":"e1fa6100","94":"0fdaad5c","96":"07f80747","265":"38121033","777":"0bc59767"}[chunkId] + ".css";
};